import React from 'react';
import PropTypes from 'prop-types';

const Heading = ({ text }) => (
  <h2 className="h1 fw-bold">{text}</h2>
);

Heading.propTypes = {
  text: PropTypes.string,
};

export default Heading;



// WEBPACK FOOTER //
// ./library/app/components/Content/Heading.js